/*
 * Wmb, Worldline Merchant Billing.
 * Copyright (C) 2017-2019 Worldline
 * All Rights Reserved
 * This product is protected by copyright. Any copying or distribution
 * is forbidden without the agreement of Worldline.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
    production: false,
    importLib: true,
    configuration: {
        jsonFileName: 'configuration-production.json'
    },

    security: {
        noSecurityTokenFor: ['/.*asset.*/', '/\/auth.*/'],

        notification: {
            error_events: ['TOKEN_EXPIRED', 'NOT_AUTHENTICATED'],
            info_events: [], // ['START', 'INITIALIZED', 'TOKEN_REFRESHED', 'TOKEN_VALIDITY_CHECKED'],
            warn_events: ['LOGGED_IN', 'LOGGED_OUT'],
        }
    },

    defaultCancelNotificationLifeTime: 5000,
    defaultLongNotificationLifeTime: 30000,

    defaultComponentErrorMessageInTooptip: true,

    log: {
        // l'url de l'api qui va recevoir une requete post , message et niveau de log sinon undefined
        // apiUrl: 'http://localhost:8087/log',apiUrl: undefined,
        apiUrl: undefined,
        // niveau de log dans le browser
        clientLevelLog: NgxLoggerLevel.DEBUG,
        // niveau de log à envoyer au serveur
        serverLevelLog: NgxLoggerLevel.ERROR
    }
};
